import React, { FC } from 'react';

import S from './style/HeaderValueList';

interface HeaderValueListProps {
  listItems: {
    header: string;
    value: string;
    isImportant?: boolean;
  }[];
}

const HeaderValueList: FC<HeaderValueListProps> = ({ listItems }) => (
  <S.List data-cy="header-value-list">
    {listItems.map((item, idx) => (
      // disabled because the list is static and it's safe to use an idx as a value
      // eslint-disable-next-line react/no-array-index-key
      <S.LItem key={idx}>
        <S.ListItemHeader>{item.header}</S.ListItemHeader>
        <S.ListItemValue isImportant={item.isImportant}>{item.value}</S.ListItemValue>
      </S.LItem>
    ))}
  </S.List>
);

export default HeaderValueList;
